import React from "react";

function Verifed({ width = 20, height = 20, fill = "#7C6060" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9_67129)">
        <path
          d="M11.5251 1.0572L4.52509 2.76831C3.62981 2.98716 3 3.78947 3 4.71111V13.2131C3 16.5788 4.91741 19.6505 7.94111 21.1288L11.5608 22.8984C11.6994 22.9661 11.8497 23 12 23C12.1503 23 12.3006 22.9661 12.4392 22.8984L16.0589 21.1288C19.0826 19.6505 21 16.5788 21 13.2131V4.71111C21 3.78947 20.3702 2.98716 19.4749 2.76831L12.4749 1.0572C12.3189 1.01907 12.1595 1 12 1C11.8405 1 11.6811 1.01907 11.5251 1.0572ZM16.7071 9.70711C17.0976 9.31659 17.0976 8.68342 16.7071 8.2929C16.3166 7.90237 15.6834 7.90237 15.2929 8.29289L11 12.5857L8.7071 10.2929C8.31657 9.90237 7.68341 9.90237 7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.2929 11.7071L10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L16.7071 9.70711Z"
          clipRule="evenodd"
          fill={fill}
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}

export default Verifed;
